import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import marketingImg from './assets/marketing.jpg';
import hiltonImg from './assets/hilton.png';
import mtnImg from './assets/MTN.png';
import orangeImg from './assets/orange.png';
import EvolveVideo from './assets/Evolve.mp4';
import Video1 from './assets/1.mp4';
import Video2 from './assets/2.mp4';
import Video3 from './assets/3.mp4';

const TRANSLATIONS = {
  fr: {
    heroSlogan: "Votre accélérateur de visibilité digitale",
    nav: { home: "Accueil", partners: "Partenaires", faq: "FAQ", contact: "Contact" },
    services: {
      marketing: { title: "Marketing Digital" }
    },
    partners: "Nos Partenaires",
    faq: "FAQ",
    contact: "Contact",
    cta: { contact: "Contact", subscribe: "S’abonner", newsletter: "Restez informé !", visit: "Contact", contactUs: "Contact", follow: "Suivez-nous" },
    newsletter: "Newsletter",
    copyright: "© 2025 Evolve Communication Agency. Tous droits réservés.",
    address: "Derrière l’ambassade d’Espagne, Bastos, Yaoundé, Cameroun",
    faqData: [
      { q: "Quels services proposez-vous ?", a: "Marketing Digital et Évènementiel." },
      { q: "Où êtes-vous basés ?", a: "Bastos, Yaoundé, Cameroun." },
      { q: "Comment vous contacter ?", a: "Via WhatsApp ou notre email." },
      { q: "Quels sont vos tarifs ?", a: "Sur devis uniquement." },
      { q: "Faites-vous du SEO ?", a: "Oui, c'est notre spécialité." },
      { q: "Organisez-vous des mariages ?", a: "Oui, tout événement." },
      { q: "Quelle zone ?", a: "Région CEMAC." },
      { q: "Payer en XAF ?", a: "Oui." },
      { q: "Réseaux sociaux ?", a: "Oui." },
      { q: "Conseil ?", a: "Oui." },
      { q: "Formations ?", a: "Oui." },
      { q: "Délai ?", a: "Variable." },
      { q: "Clients ?", a: "PME et grands comptes." },
      { q: "Design ?", a: "Inclus." },
      { q: "Disponibilité ?", a: "24h." },
      { q: "Lancer un projet ?", a: "Contactez-nous." }
    ]
  },
  en: {
    heroSlogan: "Your digital visibility accelerator",
    nav: { home: "Home", partners: "Partners", faq: "FAQ", contact: "Contact" },
    services: {
      marketing: { title: "Digital Marketing" }
    },
    partners: "Our Partners",
    faq: "FAQ",
    contact: "Contact",
    cta: { contact: "Contact", subscribe: "Subscribe", newsletter: "Stay informed!", visit: "Contact", contactUs: "Contact", follow: "Follow us" },
    newsletter: "Newsletter",
    copyright: "© 2025 Evolve Communication Agency. All rights reserved.",
    address: "Behind the Spanish Embassy, Bastos, Yaoundé, Cameroon",
    faqData: [
      { q: "What services do you offer?", a: "Digital Marketing and Event Planning." },
      { q: "Where are you based?", a: "Bastos, Yaoundé, Cameroon." },
      { q: "How can we contact you?", a: "Via WhatsApp or email." },
      { q: "What are your rates?", a: "By quote only." },
      { q: "Do you offer SEO?", a: "Yes, it's our specialty." },
      { q: "Do you organize weddings?", a: "Yes, all types of events." },
      { q: "Which region?", a: "CEMAC region." },
      { q: "Can I pay in XAF?", a: "Yes." },
      { q: "Social media management?", a: "Yes." },
      { q: "Consulting?", a: "Yes." },
      { q: "Training?", a: "Yes." },
      { q: "Deadlines?", a: "Variable." },
      { q: "Clients?", a: "SMEs and large accounts." },
      { q: "Design?", a: "Included." },
      { q: "Availability?", a: "24/7." },
      { q: "Start a project?", a: "Contact us." }
    ]
  }
};

const PARTNERS = ["FAMOUS", "HILTON", "MINJEC", "MTN", "ORANGE", "CAMTEL", "UBA", "AFRILAND", "NESTLÉ", "BRASSERIES", "TOTAL", "BOLLORE", "CIMENCAM", "SABC", "GUINNESS", "VISA"];

const FollowerWidget = ({ isVisible, isExited }) => {
  const [count, setCount] = useState(1);
  useEffect(() => {
    if (!isVisible) return;
    let start = 1;
    const end = 132;
    const duration = 2000;
    const increment = (end - start) / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible]);
  return (
    <div className={`follower-widget ${isVisible ? 'visible' : ''} ${isExited ? 'exit-up' : ''}`}>
      <div className="count">{count}k followers</div>
      <div className="platforms">Facebook | TikTok | Instagram</div>
    </div>
  );
};

import StatsWidget from './StatsWidget';

const PuzzleService = ({ service, id, imageUrl, t }) => {
  const sectionRef = useRef(null);
  const [sequence, setSequence] = useState({ text: false, widget: false, stats: false, img: false, btn: false, logo1: false, logo2: false, logo3: false });

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      // Calculate progress based on how much of the 200vh section has been scrolled
      // progress starts at 0 when section top is at 0, reaches 1 when section bottom is at viewport bottom
      const totalScrollable = rect.height - viewportHeight;
      const progress = Math.max(0, Math.min(-rect.top / totalScrollable, 1));

      setSequence({
        text: progress > 0.02,
        widget: progress > 0.08,
        stats: progress > 0.15,
        img: progress > 0.22,
        btn: progress > 0.30,
        logo1: progress > 0.38,
        logo2: progress > 0.42,
        logo3: progress > 0.46,
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section ref={sectionRef} id={id} className={`puzzle-section ${id}`}>
      <div className="puzzle-sticky-container">
        <div className="marketing-wrapper">
          <div className="image-wrapper">
            <div className={`image-container animate-item ${sequence.img ? 'visible' : ''}`}>
              <img src={imageUrl} alt={service.title} className="service-image" />
            </div>
            {id === 'marketing' && <FollowerWidget isVisible={sequence.widget} />}
            {id === 'marketing' && <StatsWidget isVisible={sequence.stats} />}
          </div>
          <div className={`marketing-text animate-item blur ${sequence.text ? 'visible' : ''}`}>
            <h3>
              Augmenter sa visibilité, <br />c'est accroitre ses revenus.
            </h3>
            <div className={`animate-item ${sequence.btn ? 'visible' : ''} marketing-cta-wrapper`}>
              <a href="https://wa.me/237697740125" target="_blank" rel="noopener noreferrer" className="cta-btn whatsapp">WhatsApp</a>
            </div>
          </div>
        </div>
        <div className="trust-logos-section">
          <div className={`animate-item ${sequence.logo1 ? 'visible' : ''} trust-title`}>
            ILS NOUS ONT FAIT CONFIANCE
          </div>
          <div className="trust-logos-container">
            <div className={`animate-item ${sequence.logo1 ? 'visible' : ''}`}>
              <img src={hiltonImg} alt="Hilton" className="trust-logo-img" />
            </div>
            <div className={`animate-item ${sequence.logo2 ? 'visible' : ''} trust-logo-stack`}>
              <img src={mtnImg} alt="MTN" className="trust-logo-img" />
            </div>
            <div className={`animate-item ${sequence.logo3 ? 'visible' : ''} trust-logo-stack`}>
              <img src={orangeImg} alt="Orange" className="trust-logo-img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

import './RealisationSection.css';


const CardVideo = ({ url, isActive }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (isActive) {
      const playVideo = () => {
        video.play().catch(e => console.error("Autoplay was prevented:", e));
      };
      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener('canplay', playVideo);
        return () => video.removeEventListener('canplay', playVideo);
      }
    } else {
      video.pause();
      video.currentTime = 0;
    }
  }, [isActive]);

  return (
    <video
      ref={videoRef}
      autoPlay
      loop
      muted
      playsInline
      className="card-video"
      preload="auto"
    >
      <source src={url} type="video/mp4" />
    </video>
  );
};

const RealisationSection = ({ projects: defaultProjects }) => {
  const sectionRef = useRef(null);
  const [activeCardIndex, setActiveCardIndex] = useState(0);

  const projects = defaultProjects || [
    { title: "FETES", category: "Evènements", date: "JUIN 24, 2024", videoUrl: Video1 },
    { title: "CONFERENCE", category: "BRANDING", date: "MAI 12, 2024", videoUrl: Video2 },
    { title: "SOIREES", category: "Concerts", date: "MARS 02, 2024", videoUrl: Video3 },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const { top } = sectionRef.current.getBoundingClientRect();
      const scrollPos = -top;
      const sectionHeight = sectionRef.current.offsetHeight;
      const progress = Math.max(0, Math.min(1, scrollPos / (sectionHeight - window.innerHeight)));
      const index = Math.floor(progress * projects.length);
      setActiveCardIndex(index);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [projects.length]);

  return (
    <section ref={sectionRef} id="realisation" className="realisation-section" style={{ height: `${projects.length * 100}vh` }}>
      <div className="realisation-sticky-wrapper">
        <h2 className="section-title">NOS RÉALISATIONS</h2>
        <div className="realisation-cards-container">
          {projects.map((p, i) => (
            <div
              key={i}
              className={`project-card ${i === activeCardIndex ? 'active' : ''} ${i < activeCardIndex ? 'exited' : ''}`}
              style={{
                zIndex: projects.length - i
              }}
            >
              {p.videoUrl && <CardVideo url={p.videoUrl} isActive={i === activeCardIndex} />}
              <div className="card-overlay">
                <div className="card-top">
                  <span className="card-category">{p.category}</span>
                  <span className="card-date">{p.date}</span>
                </div>
                <h3 className="project-title">{p.title}</h3>
                <div className="card-bottom">
                  <a href="#" className="view-cta">EXPLORER</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

function App() {
  const [lang, setLang] = useState('fr');
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const t = TRANSLATIONS[lang];
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const playVideo = () => {
        video.play().catch(e => console.log("Autoplay blocked:", e));
      };
      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener('canplay', playVideo);
        return () => video.removeEventListener('canplay', playVideo);
      }
    }
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      if (window.scrollY > 50 && mobileMenuOpen) setMobileMenuOpen(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [mobileMenuOpen]);

  const toggleMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <div className="app-container">
      <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="nav-logo">EV<span style={{color: '#F5A623', fontWeight: '300'}}>O</span>LVE</div>

        <div className={`nav-links ${mobileMenuOpen ? 'active' : ''}`}>
          <button className="nav-link-btn" onClick={() => { window.location.href = '#home'; closeMenu(); }}>{t.nav.home}</button>
          <button className="nav-link-btn" onClick={() => { window.location.href = '#partners'; closeMenu(); }}>{t.nav.partners}</button>
          <a href="#faq" className="nav-link-btn" onClick={closeMenu}>{t.nav.faq}</a>
          <a href="#contact" className="nav-link-btn" onClick={closeMenu}>{t.nav.contact}</a>
          <button className="lang-switcher mobile-only" onClick={() => { setLang(l => l === 'fr' ? 'en' : 'fr'); closeMenu(); }}>{lang === 'fr' ? 'EN' : 'FR'}</button>
        </div>

        <div className="nav-actions">
          <button className="lang-switcher desktop-only" onClick={() => setLang(l => l === 'fr' ? 'en' : 'fr')}>{lang === 'fr' ? 'EN' : 'FR'}</button>
          <button className={`hamburger ${mobileMenuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <main>
        <section id="home" className="section hero-section">
          <video ref={videoRef} autoPlay loop muted playsInline className="hero-video"><source src={EvolveVideo} type="video/mp4" /></video>
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="hero-logo">EV<span style={{color: '#F5A623', fontWeight: '300'}}>O</span>LVE</div>
            <h1 className="hero-slogan">{t.heroSlogan}</h1>
          </div>
        </section>

        <PuzzleService service={t.services.marketing} id="marketing" t={t} imageUrl={marketingImg} />

        <RealisationSection />

        <section id="partners" className="partners-section">
          <h2>{t.partners}</h2>
          <div className="carousel"><div className="carousel-track">{[...PARTNERS, ...PARTNERS].map((p, i) => <div key={i} className="partner-card">{p}</div>)}</div></div>
        </section>

        <section id="faq" className="faq-section">
          <h2>{t.faq}</h2>
          <div className="faq-grid">{t.faqData.map((item, i) => <div key={i} className="faq-item"><h4>{item.q}</h4><p>{item.a}</p></div>)}</div>
        </section>
      </main>

      <footer id="contact" className="footer">
        <div className="contact-grid">
          <div className="contact-col"><h3>{t.cta.visit}</h3><p>{t.address}</p></div>
          <div className="contact-col"><h3>{t.cta.contactUs}</h3><p><a href="mailto:hello@evolvecmr.com" style={{color: 'white'}}>hello@evolvecmr.com</a></p><p><a href="https://wa.me/237697740125" style={{color: 'white'}}>+237 697 740 125</a></p></div>
          <div className="contact-col"><h3>{t.cta.follow}</h3>
            <div className="social-links"><a href="#" aria-label="Instagram"><span className="icon-insta">ig</span></a><a href="#" aria-label="Facebook"><span className="icon-fb">f</span></a><a href="#" aria-label="Twitter"><span className="icon-x">𝕏</span></a><a href="#" aria-label="LinkedIn"><span className="icon-in">in</span></a></div>
          </div>
          <div className="contact-col newsletter"><h3>{t.newsletter}</h3><p>{t.cta.newsletter}</p>
            <form onSubmit={(e) => e.preventDefault()}><input type="email" placeholder="email@example.com" required /><button type="submit">{t.cta.subscribe}</button></form>
          </div>
        </div>
        <p style={{marginTop: '50px', opacity: 0.5}}>{t.copyright}</p>
      </footer>
    </div>
  );
}

export default App;
